module.exports = __webpack_public_path__ + "static/oostende-6d61503797cab4a78722164ed3be7a73.png";